<div class="progress-linear"
     role="progressbar">
    <div class="indeterminate-progress-bar">
        <div class="bar"> </div>
    </div>
</div>
